import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { Box, Row } from '../layout';
import { styled, Theme } from '../../styles';
import { AppIcon } from '../icons';
import { AppText } from '../typography';
import { Tooltip } from '../tooltip/tooltip';
const DEFAULT_TEXT = 'Note successfully sent';
export const NoteSuccessfullySent = ({ recordTooltipHover, style, text = DEFAULT_TEXT, }) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const handleOnMouseEnter = () => {
        recordTooltipHover?.();
        setShowTooltip(true);
    };
    const hanleOnMouseLeave = () => {
        setShowTooltip(false);
    };
    return (_jsx(Container, { "data-testid": "note-successfully-sent", onMouseEnter: handleOnMouseEnter, onMouseLeave: hanleOnMouseLeave, children: _jsx(Tooltip, { showTooltip: showTooltip, message: _jsx("span", { children: "Note will continue to update for some platforms" }), children: _jsxs(MessageWrapper, { style: style, children: [_jsx(AppIcon, { name: "DoneIcon", color: Theme.colors.green50 }), _jsx(AppText, { as: "span", children: text })] }) }) }));
};
const Container = styled(Box)(() => ({
    alignItems: 'center',
    display: 'inline-flex',
}));
const MessageWrapper = styled(Row)(({ theme }) => ({
    alignItems: 'center',
    background: theme.colors.grey05,
    borderRadius: '.625rem',
    height: '2rem',
    justifyContent: 'center',
    margin: '.25rem',
    width: '15rem',
}));
//# sourceMappingURL=note_successfully_sent.js.map